import { render, staticRenderFns } from "./nshop-order-view.vue?vue&type=template&id=4c0e30f8&scoped=true&"
import script from "./nshop-order-view.vue?vue&type=script&lang=js&"
export * from "./nshop-order-view.vue?vue&type=script&lang=js&"
import style0 from "./nshop-order-view.vue?vue&type=style&index=0&id=4c0e30f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0e30f8",
  null
  
)

export default component.exports